import { ChangeDetectorRef, Component, OnInit, OnDestroy, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { BaseComponent } from '../../forms/base-form/base-form.component';
import { DialogService } from 'src/app/services/dialog.service';
import { DrupalRESTService } from 'src/app/services/drupal-rest.service';
import { EntityRESTService } from 'src/app/services/entity-rest.service';
import { FieldsService } from 'src/app/services/fields.service';
import { TaxonomyService } from 'src/app/services/taxonomy.service';
import { UtilityService } from 'src/app/services/utility.service';
import { AuthRESTService } from 'src/app/services/auth-rest.service';
import { AuthService } from 'src/app/services/auth.service';
import { MenuRESTService } from 'src/app/services/menu-rest.service';
import { RouteEventsService } from 'src/app/route-events.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ConfigPagesService } from 'src/app/services/config-pages.service';
import { PackagesService } from 'src/app/services/packages.service';
import { UserService } from 'src/app/services/user.service';
import { RefreshService } from 'src/app/services/refresh.service';
import { StudioConfigService } from 'src/app/services/studio-config.service';
import { ComponentRefreshService } from 'src/app/services/component-refresh.service';
import { CalendarOptions, FullCalendarComponent } from '@fullcalendar/angular';
import momentTimezonePlugin from '@fullcalendar/moment-timezone';
import momentPlugin from '@fullcalendar/moment';
import moment from 'moment';
import { ComponentType } from '@angular/cdk/portal';
import $ from "jquery";

// Tippy JS
import tippy from 'tippy.js';
import { hideAll, roundArrow } from 'tippy.js';

// Import all form components used in dialogs and popovers
// Ensure these paths are correct for your project structure
import { LessonComponent } from 'src/app/components/forms/lesson/lesson.component';
import { GroupLessonComponent } from 'src/app/components/forms/group-lesson/group-lesson.component';
import { SchedulesComponent } from 'src/app/components/forms/schedules/schedules.component';
import { ServicesComponent } from 'src/app/components/forms/services/services.component';
import { StudentAccountComponent } from 'src/app/components/forms/student-account/student-account.component';
import { AppointmentDetailsComponent } from 'src/app/components/forms/appointment-details/appointment-details.component';
import { InquiryComponent } from 'src/app/components/forms/inquiry/inquiry.component';
import { EventLessonEntityComponent } from 'src/app/components/forms/event-lesson-entity/event-lesson-entity.component';
import { PaymentsEntityComponent } from 'src/app/components/forms/payments-entity/payments-entity.component';
import { EventSchedulesEntityComponent } from 'src/app/components/forms/event-schedules-entity/event-schedules-entity.component';
import { StudentInquiryEntityComponent } from 'src/app/components/forms/student-inquiry-entity/student-inquiry-entity.component';
import { BookingMenuChoice } from 'src/app/components/shared/booking-menu/booking-menu.component';
import { EventGroupLessonEntityComponent } from 'src/app/components/forms/event-group-lesson-entity/event-group-lesson-entity.component';
import { EventServicesEntityComponent } from 'src/app/components/forms/event-services-entity/event-services-entity.component';
import { UpdateLessonComponent } from 'src/app/components/forms/update-lesson/update-lesson.component';
import { UpdateGroupLessonComponent } from 'src/app/components/forms/update-group-lesson/update-group-lesson.component';
import { UpdateServiceComponent } from 'src/app/components/forms/update-service/update-service.component';
import { WeekCalculationService } from 'src/app/services/week-calculation.service';
import { EventColorService } from 'src/app/services/event-color.service';
import { getCalendarTimeFormat } from 'src/app/constants/calendar.constants';
import { LoggerService } from '../../../services/logger.service';

/**
 * IMPORTANT NOTE: Year Boundary Fix
 * (Comment moved from DayViewComponent)
 */
@Component({
  selector: 'app-base-calendar',
  templateUrl: './base-calendar.component.html',
  styleUrls: ['./base-calendar.component.css']
})
export class BaseCalendarComponent extends BaseComponent implements OnInit, OnDestroy {

  @ViewChild('calendar') override calendarComponent: FullCalendarComponent;
  @ViewChild('customPopover') customPopover: ElementRef;

  // Week calculation service for correct Week 53 handling
  protected weekCalculationService: WeekCalculationService;

  constructor(
    refreshService: RefreshService,
    dialogService: DialogService,
    entityRESTService: EntityRESTService,
    utilityService: UtilityService,
    fieldsService: FieldsService,
    drupalRESTService: DrupalRESTService,
    taxonomyService: TaxonomyService,
    router: Router,
    activatedRoute: ActivatedRoute,
    authRESTService: AuthRESTService,
    authService: AuthService,
    menuRESTService: MenuRESTService,
    formBuilder: FormBuilder,
    routeEventsService: RouteEventsService,
    permissionsService: PermissionsService,
    renderer2: Renderer2,
    configPages: ConfigPagesService,
    packagesService: PackagesService,
    snackBar: MatSnackBar,
    userRESTService: UserService,
    el: ElementRef,
    changeDetectorRef: ChangeDetectorRef,
    sanitizer: DomSanitizer,
    studioConfigService: StudioConfigService,
    componentRefreshService: ComponentRefreshService,
    translateService: TranslateService,
    weekCalculationService: WeekCalculationService,
    private _eventColorService: EventColorService
  ) {
    super(
      refreshService,
      dialogService,
      entityRESTService,
      utilityService,
      fieldsService,
      drupalRESTService,
      taxonomyService,
      router,
      activatedRoute,
      authRESTService,
      authService,
      menuRESTService,
      formBuilder,
      routeEventsService,
      permissionsService,
      renderer2,
      configPages,
      packagesService,
      snackBar,
      userRESTService,
      el,
      changeDetectorRef,
      sanitizer,
      studioConfigService,
      componentRefreshService,
      translateService
    );
    this.weekCalculationService = weekCalculationService;
  }

  // Component type references for dialogs/popovers (public for template access)
  public LessonComponent = LessonComponent;
  public GroupLessonComponent = GroupLessonComponent;
  public SchedulesComponent = SchedulesComponent;
  public ServicesComponent = ServicesComponent;
  public StudentAccountComponent = StudentAccountComponent;
  public InquiryComponent = InquiryComponent;
  public EventLessonEntityComponent = EventLessonEntityComponent;
  public PaymentsEntityComponent = PaymentsEntityComponent;
  public EventSchedulesEntityComponent = EventSchedulesEntityComponent;
  public StudentInquiryEntityComponent = StudentInquiryEntityComponent;
  public EventGroupLessonEntityComponent = EventGroupLessonEntityComponent;
  public EventServicesEntityComponent = EventServicesEntityComponent;
  public UpdateLessonComponent = UpdateLessonComponent;
  public UpdateGroupLessonComponent = UpdateGroupLessonComponent;
  public UpdateServiceComponent = UpdateServiceComponent;
  public AppointmentDetailsComponent = AppointmentDetailsComponent;

  // Properties moved from DayViewComponent
  public copyData: any = {};
  public AMTConfiguration: any = ""; // Potentially used by child templates or specific logic
  public InstructorList: {} = "";   // Same as above
  public AMTCalendarConfiguration: any = "";
  public AMTSessionTime: any;

  public Events: any[] = [];
  public Resources: any[] = [];

  // Filter configuration (public for child component or template access)
  public filterInstructorCategory: string[];
  public filterLessonType: any;
  public filterInstructor: string[] = [];
  public filterStudent: string = "";
  public filterDate: string = ""; // Updated by calendar navigation
  public filterGroupLesson: boolean = false;
  public filterLesson: boolean = false;
  public filterServices: boolean = false;
  public filterHiddenEvents: boolean = false;

  // FullCalendar related state for popovers/dialogs
  public currentSelectedInstructorID: string;
  public currentSelectedDuration: string;
  public currentSelectedStartTime: string;

  public summaryCount = {
    privateLessonDaily: 0,
    privateLessonWeekly: 0,
    privateTakenLessonDaily: 0,
    privateTakenLessonWeekly: 0,
  };

  // Per-category breakdown (DE / Pre / Bonus / Front / Back / Coaching / Other)
  // backing the Overall Summary dropdown. Aggregated across all instructors from
  // each resource's categoryBreakdown returned by the backend.
  public summaryBreakdown: {
    key: string;
    label: string;
    bookedDaily: number;
    takenDaily: number;
    bookedWeekly: number;
    takenWeekly: number;
  }[] = [];

  protected newDateStart: string;
  protected newDateEnd: string;
  // protected calendarDateInquiry: string; // Was set but not used in DayViewComponent

  // TippyJS related
  protected tippyHideDuration = 100;
  protected tippyInstructorHoverInstances = new Map();
  public weekNumber: string; // Used in default titleFormat, public if needed by children

  protected intervalId: any;
  protected noTippy: boolean = false;
  public isDragging: boolean = false; // Public if child templates need to react to it

  // Caching for next events
  protected nextEventsCache = new Map<string, any>();
  protected pendingRequests = new Map<string, Promise<any>>();

  public calendarOptions: CalendarOptions;


  ngOnInit(): void {
    this.getAMTCalendarConfiguration(); // Fetches config that might alter calendarOptions defaults
    this.getAMTFilterConfiguration();
    this.getAMTSessionTime();
    // this.getInstructorList(); // Uncomment if needed for general calendar setup
    // this.getAMTAutocomplete(); // Uncomment if needed

    this.initializeCalendarOptions(); // Initialize after essential configs are fetched

    this.intervalId = setInterval(() => {
      this.refreshCalendar();
    }, 60000);
  }

  ngOnDestroy(): void {
    this._dialogService.closeAll();
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
    this.tippyInstructorHoverInstances.forEach(instance => instance.destroy());
    this.tippyInstructorHoverInstances.clear();
    this.nextEventsCache.clear();
    this.pendingRequests.forEach(p => { /* Potentially abort pending requests if possible */ });
    this.pendingRequests.clear();
  }

  protected initializeCalendarOptions(): void {
    // Default options, some of which will be overridden by getAMTCalendarConfiguration
    // or by child component overrides.
    this.calendarOptions = {
      timeZone: 'local',
      plugins: [momentPlugin, momentTimezonePlugin], // momentTimezonePlugin added
      firstDay: 0, // Sunday
      schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
      initialView: this.getInitialView(),
      height: "auto",
      refetchResourcesOnNavigate: true,
      allDaySlot: false,
      slotEventOverlap: false, // Don't allow events to overlap.
      droppable: true,
      editable: true,
      nextDayThreshold: '00:00:00', // Set to true to handle events spanning midnight properly

      events: (fetchInfo, successCallback, failureCallback) => this.getCalendarEvents()(fetchInfo, successCallback, failureCallback),
      resources: (fetchInfo, successCallback, failureCallback) => this.getCalendarResources()(fetchInfo, successCallback, failureCallback),

      loading: (isLoading: boolean) => {
        if (!isLoading) {
          // Hide custom popover if mouse hover exits.
          $("#custom-popover").off('mouseleave').on('mouseleave', function () { $(this).hide(); }); // Use .off().on() to prevent multiple bindings
          // Hide custom context menu if mouse hover exits.
          $("#custom-context-menu").off('mouseleave').on('mouseleave', function () { $(this).hide(); });
        }
      },

      eventDrop: this.handleEventDrop.bind(this),
      eventResize: this.handleEventResize.bind(this),
      eventContent: this.handleEventContent.bind(this),
      eventDidMount: this.handleEventDidMount.bind(this),
      customButtons: this.getCustomButtons(),
      headerToolbar: this.getHeaderToolbar(),
      titleFormat: this.formatCalendarTitle.bind(this),
      eventClick: this.handleEventClick.bind(this),
      eventMouseLeave: this.handleEventMouseLeave.bind(this),
      selectable: true,
      select: this.handleSelect.bind(this),
      selectOverlap: (event) => false, // Prevent selection when overlapping an event
      selectAllow: this.handleSelectAllow.bind(this),
      dateClick: this.handleDateClick.bind(this), // For right-click paste, etc.
      resourceLabelDidMount: this.handleResourceLabelDidMount.bind(this),
      // resourceLabelWillUnmount: (unmountArg) => { /* Original was commented out */ },

      // Default slot configurations (can be overridden by AMTCalendarConfiguration)
      slotDuration: this.AMTCalendarConfiguration?.duration || "00:15:00",
      slotLabelInterval: this.AMTCalendarConfiguration?.slot_interval || "00:15:00", // Defaulting to 15min, original DayView had 1min
      displayEventTime: this.AMTCalendarConfiguration?.event_time ?? false, // Use ?? for boolean
      resourceOrder: this.AMTCalendarConfiguration?.resourceOrder || 'order_id', // Default from fetched config
      slotLabelFormat: {
        hour: 'numeric',
        minute: '2-digit',
        omitZeroMinute: false,
        meridiem: 'short'
      },
      // slotMinTime & slotMaxTime are set dynamically in getCalendarResources and getAMTCalendarConfiguration
    };
  }

  // --- START: Methods for Calendar Options Customization by Child Components ---
  protected getInitialView(): string {
    return 'resourceTimeGridDay'; // Default, e.g., DayViewComponent will use this
  }

  protected getCustomButtons(): any {
    return {
      goBackAWeek: {
        text: '<<',
        hint: 'Go back a week',
        click: () => {
          this.calendarComponent?.getApi()?.incrementDate({ weeks: -1 });
        }
      },
      goForwardWeek: {
        text: '>>',
        hint: 'Go forward a week',
        click: () => {
          this.calendarComponent?.getApi()?.incrementDate({ weeks: 1 });
        }
      }
      // Child components can add more buttons by overriding this or merging
    };
  }

  protected getHeaderToolbar(): any {
    return {
      start: 'goBackAWeek,prev,today,next,goForwardWeek', // Common controls
      center: 'title',
      end: '' // Child can add 'timeGridDay,timeGridWeek,dayGridMonth' or other view switchers
    };
  }

  protected formatCalendarTitle(dateInfo: any): string {
    // Default title formatting, can be overridden by specific views
    const endMarker = dateInfo.end // FullCalendar provides Date objects
    let newTitleFormat = moment(endMarker).format('dddd[,] MMMM DD[, ]YYYY[ - Week #]');
    // Use custom week calculation for correct Week 53 handling
    const weekNum = this.weekCalculationService.getWeekNumber(endMarker.toISOString());
    this.weekNumber = weekNum.toString();
    newTitleFormat += this.weekNumber;
    return newTitleFormat;
  }
  // --- END: Methods for Calendar Options Customization ---


  // --- START: FullCalendar Event Handlers (Copied from DayViewComponent) ---
  // Ensure 'this' context is correct by binding in initializeCalendarOptions or using arrow functions
  protected handleEventDrop(info: any): void {
    let eventID = info?.oldEvent?._def?.extendedProps?.entityId;
    let eventType = info?.event?._def?.extendedProps?.appointmentType;
    // Use info.event.startStr (FullCalendar's tz-aware ISO string with the studio offset)
    // and parseZone to keep the dropped slot's wall-clock fields verbatim. No conversion
    // to the browser timezone. field_date_and_time is stored naive (wall-clock), so this
    // sends exactly the time the event was dropped on. The responseTimeUTC compare below
    // parses the echoed value the same way so the equality check stays in one frame.
    let newStartTime = moment.parseZone(info.event.startStr).format('YYYY-MM-DDTHH:mm:ss');
    let newInstructor = info?.newResource?._resource?.id;
    // field_status is the attendee-resolved status; a group lesson with mixed
      // attendee statuses has none, so also lock when any attendee is charged.
      let isPosted = info?.event?._def?.extendedProps?.['eventDetails']?.data?.field_status == '59'
        || !!info?.event?._def?.extendedProps?.['groupHasPosted'];

    hideAll({ duration: this.tippyHideDuration });
    this.noTippy = true;
    this.isDragging = true;

    if (isPosted) {
      info.revert();
      this.showSnackbar('Posted events cannot be moved.');
      this.isDragging = false;
      return;
    }

    let patchData: any = { 'field_date_and_time': newStartTime };
    if (eventType === 'schedules') { patchData['field_schedule_instructor'] = newInstructor; }
    else if (eventType === 'services') { patchData['field_executive'] = newInstructor; }
    else { patchData['field_instructor'] = newInstructor; }

    this._entityRESTService.patchEntity('events', eventType, eventID, patchData).subscribe({
      next: (data: any) => {
        // The stored field_date_and_time is naive studio wall-clock (no tz suffix).
        // parseZone reads its fields verbatim, matching newStartTime above (also a naive
        // wall-clock value) so the compare is browser-independent. Plain moment(value).utc()
        // would shift by the browser offset and break the equality check off-UTC.
        let responseWallClock = moment.parseZone(data?.field_date_and_time[0]?.value).format('YYYY-MM-DDTHH:mm:ss');
        if (responseWallClock !== newStartTime) {
          info.revert();
          this.showSnackbar('Event is already posted. Unable to update the date and time.');
        }
      },
      error: (error) => { info.revert(); this.showSnackbar('An error occurred while updating.'); this.handleError(error);},
      complete: () => { this.noTippy = false; this.isDragging = false; this.refreshCalendar(); }
    });
  }

  protected handleEventResize(eventResizeInfo: any): void {
    let eventID = eventResizeInfo?.oldEvent?._def?.extendedProps?.entityId;
    let eventType = eventResizeInfo?.event?._def?.extendedProps?.appointmentType;

    hideAll({ duration: this.tippyHideDuration });
    this.noTippy = true;
    this.isDragging = true;

    this._entityRESTService.patchEntity('events', eventType, eventID, {
      'field_duration': this.calcDuration(eventResizeInfo.event.start, eventResizeInfo.event.end),
    }).subscribe({
      next: (data) => { /* Success */ },
      error: (error) => { this.showSnackbar('Error resizing event.'); this.handleError(error); },
      complete: () => { this.noTippy = false; this.isDragging = false; this.refreshCalendar(); }
    });
  }

  protected handleEventContent(arg: any): { domNodes: HTMLElement[] } {
    let isConfirmed = arg.event._def.extendedProps?.['eventDetails']?.data?.isConfirmed;
    let lessonType = arg.event._def.extendedProps?.['appointmentType'];
    let contentToShow = document.createElement('div');
    contentToShow.innerHTML = arg.event._def.extendedProps['dataToShow'] || 'Event'; // Fallback content
    let confirmationStatus = document.createElement('div');
    confirmationStatus.className = "confirmation-status";
    if (lessonType == 'lesson') { // Only show for lessons
      if (isConfirmed) { confirmationStatus.innerHTML = '<span class="material-icons">check_box</span>'; }
      else { confirmationStatus.innerHTML = '<span class="material-icons">check_box_outline_blank</span>'; }
      confirmationStatus.addEventListener("click", (e: Event) => { e.stopPropagation(); this.toggleEventConfirmation(arg); });
    }

    let notesIcon = document.createElement('div');
    notesIcon.className = "notes-icon";
    notesIcon.innerHTML = '<span class="material-icons">notes</span>';
    let hasNotes = arg.event._def.extendedProps?.['eventDetails']?.data?.field_notes || arg.event._def.extendedProps?.['eventDetails']?.data?.field_reason_for_canceling;
    if (!hasNotes) { notesIcon.style.display = 'none'; }
    notesIcon.addEventListener("click", (e: Event) => e.stopPropagation()); // Prevent event click if clicking icon

    let paymentIcon = document.createElement('div');
    paymentIcon.className = "payment-icon";
    if (lessonType === 'lesson' && arg.event._def.extendedProps?.['eventDetails']?.data?.field_calendar_payment_reminder) {
      paymentIcon.innerHTML = '<span class="material-icons" style="color: #FFD700; text-shadow: 0 0 2px black;">attach_money</span>';
    } else { paymentIcon.style.display = 'none'; }

    let bookedOnlineIcon = document.createElement('div');
    bookedOnlineIcon.className = "booked-online-icon";
    if (lessonType === 'lesson' && arg.event._def.extendedProps?.['eventDetails']?.data?.bookedOnline) {
      bookedOnlineIcon.innerHTML = '<span class="material-icons" title="Booked online">language</span>';
    } else {
      bookedOnlineIcon.style.display = 'none';
    }

    return { domNodes: [confirmationStatus, contentToShow, notesIcon, paymentIcon, bookedOnlineIcon].filter(node => node !== null) };
  }

  protected handleEventDidMount(info: any): void {
    // Context Menu
    let bundle = info.event._def?.extendedProps?.['appointmentType'];
    if (bundle === 'lesson' || bundle === 'services' || bundle === 'schedules') { // Removed group_lesson to match original logic
      info.el.addEventListener("contextmenu", (jsEvent: MouseEvent) => {
        jsEvent.preventDefault();
        this.copyData = info.event?._def?.extendedProps?.['eventDetails']?.data; // Store data for context menu actions
        const contextMenu = $("#custom-context-menu");
        if (contextMenu.length) {
            const left = jsEvent.pageX;
            const top = jsEvent.pageY;
            contextMenu.show().css({
                "left": left - contextMenu.width() / 2 + "px",
                "top": top - contextMenu.height() / 2 + 20 + "px", // Offset slightly
                "display": "block"
            });
        }
      });
    }

    // Tooltip (TippyJS)
    const eventData = info.event._def?.extendedProps?.['eventDetails']?.data;
    const tooltipBaseContent = info.event.extendedProps?.['tooltip'] || '';
    if (tooltipBaseContent || (eventData?.has_next_events && !this.noTippy)) {
      let tooltipContent = `<div class="tooltip-base-content">${tooltipBaseContent}</div>`;
      if (eventData?.has_next_events) {
        tooltipContent += `<div id="next-events-content-${info.event.id}" class="next-events-loading">Loading upcoming appointments...</div>`; // Unique ID for concurrent tooltips
      }
      tippy(info.el, {
        allowHTML: true, placement: "bottom", arrow: roundArrow, animation: 'fade', theme: 'light',
        duration: [500, 0], content: tooltipContent,
        onShow: (instance) => {
          if (this.noTippy) { instance.disable(); return false; } // Prevent showing if noTippy is true
          if (eventData?.has_next_events) {
            const cacheKey = this.createNextEventsCacheKey(eventData.id, eventData.event_date);
            const nextEventsContentEl = instance.popper.querySelector(`#next-events-content-${info.event.id}`);

            if (this.nextEventsCache.has(cacheKey)) {
              const cachedData = this.nextEventsCache.get(cacheKey);
              if (nextEventsContentEl) nextEventsContentEl.innerHTML = this.formatNextEventsHtml(cachedData);
              return;
            }
            if (nextEventsContentEl) nextEventsContentEl.innerHTML = '<div class="loading-spinner">Loading...</div>';
            this.loadNextEvents(
              eventData.id, eventData.event_date, eventData.student_account_id || null,
              (data: any) => { if (nextEventsContentEl) nextEventsContentEl.innerHTML = this.formatNextEventsHtml(data); },
              (error: any) => { if (nextEventsContentEl) nextEventsContentEl.innerHTML = '<p>Error loading upcoming appointments</p>'; }
            );
          }
        },
        onHide: (instance) => {
          if (this.noTippy) { return false; } // Prevent hiding if noTippy is true
        }
      });
    }
  }

  protected handleEventClick(info: any): void {
    hideAll({ duration: this.tippyHideDuration }); // Hide tooltips on click
    const eventProps = info.event?._def?.extendedProps;
    const studentAccountId = eventProps?.['studentDetails']?.['studentAccountId'];
    const entityId = eventProps?.['entityId'];

    if (studentAccountId && entityId) {
      const currentDate = info.event.start;
      const cacheKey = this.createNextEventsCacheKey(entityId, currentDate.toISOString());

      const openDetailsDialog = (nextEventsData?: any) => {
        const enhancedInfo = { ...info, event: { ...info.event, _def: { ...info.event._def, extendedProps: { ...eventProps, upcomingEventList: (nextEventsData?.upcomingEventList) || [] }}}};
        this.openDialog(this.AppointmentDetailsComponent, "defaultWithData", enhancedInfo);
      };

      if (this.nextEventsCache.has(cacheKey)) {
        openDetailsDialog(this.nextEventsCache.get(cacheKey));
      } else {
        this.loadNextEvents(
          entityId, currentDate.toISOString(), studentAccountId,
          (data: any) => { this.nextEventsCache.set(cacheKey, data); openDetailsDialog(data); },
          (error: any) => { LoggerService.error(`[CLICK] Error fetching next events for dialog id=${entityId}:`, error); openDetailsDialog(); } // Open with empty list on error
        );
      }
    } else { // No student or entity ID, open dialog without next events
      const enhancedInfo = { ...info, event: { ...info.event, _def: { ...info.event._def, extendedProps: { ...(eventProps || {}), upcomingEventList: [] }}}};
      this.openDialog(this.AppointmentDetailsComponent, "defaultWithData", enhancedInfo);
    }
  }

  protected handleEventMouseLeave(mouseLeaveInfo: any): void {
    if (!this.noTippy) { // Only hide if not in a state where tippy should be suppressed (e.g. drag)
        hideAll({ duration: this.tippyHideDuration });
    }
  }

  protected handleSelect(info: any): void { // For selecting a time slot
    const popover = $("#custom-popover");
    if (popover.length) {
        const left = info.jsEvent.pageX;
        const top = info.jsEvent.pageY;
        popover.show().css({
            "left": left - popover.width() / 2 + "px",
            "top": top - popover.height() / 2 + 20 + "px",
            "display": "block"
        });
    }
    // Use info.startStr (FullCalendar's own tz-aware ISO string, e.g.
    // "2026-06-07T13:00:00+02:00") and parseZone to keep the studio wall-clock fields
    // verbatim. No conversion to the browser timezone or UTC. moment(info.start) would
    // re-render the marker through the browser's zone and shift the clicked time off the
    // grid for studios not in the browser's timezone. field_date_and_time is stored naive
    // (wall-clock), so we want exactly the time that was clicked.
    this.currentSelectedStartTime = moment.parseZone(info.startStr).format('YYYY-MM-DD[T]HH:mm:ss');
    this.currentSelectedDuration = this.calcDuration(info.start, info.end);
    this.currentSelectedInstructorID = info.resource?.id; // resource might be null if not resource view
    this.bookingMenuOpenKey++;
    this.loadCoachingPackages();
  }

  protected handleSelectAllow(selectInfo: any): boolean {
    // Logic from DayViewComponent (was related to #selected-hours, which is not in base HTML)
    // For now, just allow selection. Child components can override.
    return true;
  }

  protected handleDateClick(info: any): void { // Can be used for other actions on date click
    // Original DayViewComponent used this for context menu paste prep, but paste was not implemented.
    // jsEvent.preventDefault() might be needed if we don't want default browser behavior on right click.
    // if (info.jsEvent.button === 2) { /* Right click logic */ }
  }

  protected handleResourceLabelDidMount(mountArg: any): void {
    if (mountArg.resource?.extendedProps?.['info'] && !this.noTippy) {
      const tippyInstance = tippy(mountArg.el, {
        allowHTML: true, placement: "bottom", arrow: roundArrow, animation: 'fade',
        duration: [500, 0], theme: 'light', content: mountArg.resource.extendedProps['info'],
        onShow: (instance) => {
          if (this.noTippy) { return false; } // Prevent showing if noTippy is true
        },
        onHide: (instance) => {
          if (this.noTippy) { return false; } // Prevent hiding if noTippy is true
        }
      });
      this.tippyInstructorHoverInstances.set(mountArg.resource.id, tippyInstance);
    }
  }
  // --- END: FullCalendar Event Handlers ---


  // --- START: Dialog and UI Helper Methods (Copied from DayViewComponent) ---
  public openEntityComponent(component: ComponentType<unknown>, eckType: string, bundle: string, action: string, EntityID?: any, fieldsData?: {}) {
    this._dialogService.openDialog(component, "defaultWithData", {
      data: { EntityID: EntityID, eckType: eckType, bundle: bundle, action: action, fieldsData: fieldsData ?? '' },
    }).afterClosed().subscribe(() => this.refreshCalendar());
  }

  public dialogAddLessonData(configOptions: any) { // Consider more specific type for configOptions
    configOptions['data'] = {
      instructors: this.filterInstructorCategory, // Assumes filterInstructorCategory is populated
      lesson_types: this.filterLessonType         // Assumes filterLessonType is populated
    };
    return configOptions;
  }

  public openDialog(formName: ComponentType<unknown>, configName?: string, data?: any) {
    this._dialogService.openDialog(formName, configName, data)
      .afterClosed()
      .subscribe((result) => {
        // Skip refresh if the dialog already triggered one (e.g., after delete)
        if (result?.refreshed) {
          return;
        }
        setTimeout(() => this.refreshCalendar(), 1000); // Delay to allow server processing
      });
  }
  // --- END: Dialog and UI Helper Methods ---


  // --- START: Calendar Data Fetching and Processing (Copied and adapted from DayViewComponent) ---
  public updateCalendarEvents(params: any) {
    // This method is typically called by a filter component.
    // It updates the filter properties and then tells FullCalendar to refetch.
    // params might contain: filterDate, filterStudent, filterLessonType, etc.
    if (params.filterDate) this.filterDate = params.filterDate;
    if (params.filterStudent) this.filterStudent = params.filterStudent;
    if (params.filterLessonType) this.filterLessonType = params.filterLessonType;
    if (params.filterInstructorCategory) this.filterInstructorCategory = params.filterInstructorCategory;
    if (params.filterGroupLesson !== undefined) this.filterGroupLesson = params.filterGroupLesson;
    if (params.filterLesson !== undefined) this.filterLesson = params.filterLesson;
    if (params.filterServices !== undefined) this.filterServices = params.filterServices;
    if (params.filterHiddenEvents !== undefined) this.filterHiddenEvents = params.filterHiddenEvents;

    if (this.calendarComponent && this.calendarComponent.getApi()) {
      if (params.filterDate) {
        this.calendarComponent.getApi().gotoDate(moment(params.filterDate).toISOString());
      }
      // Re-assigning event/resource sources to trigger refetch with new parameters
      // This is a bit of a hack. Better to use refetchEvents() and refetchResources()
      // if the getCalendarEvents/Resources methods correctly use the this.filter... properties.
      // For now, matching original behavior:
      // this.calendarOptions.events = this.getCalendarEvents(params);
      // this.calendarOptions.resources = this.getCalendarResources(params);
      // More robust way:
      this.refreshCalendar();
    }
  }

  public getCalendarEvents(filterParamsOverride: any = null) {
    // Returns a function for FullCalendar's `events` property
    return (fetchInfo: any, successCallback: (events: any[]) => void, failureCallback: (error: any) => void) => {
      this.getAMTSessionTime(); // Refreshes session time display (e.g., grayed out slots)

      // Base endpoint, child views might need to customize this
      let endpoint = this.getEventsEndpoint();

      this.newDateStart = moment(fetchInfo.startStr).toISOString();
      this.newDateEnd = moment(fetchInfo.endStr).toISOString();

      // Build query parameters
      const queryParams: string[] = [];
      queryParams.push(`start=${this.newDateStart}`);
      queryParams.push(`end=${this.newDateEnd}`);

      // Use filterParamsOverride if provided, otherwise use component's filter state
      const activeFilters = filterParamsOverride || {
        filterDate: this.filterDate,
        filterStudent: this.filterStudent,
        filterLessonType: this.filterLessonType,
        filterInstructorCategory: this.filterInstructorCategory,
        filterGroupLesson: this.filterGroupLesson,
        filterLesson: this.filterLesson,
        filterServices: this.filterServices,
        filterHiddenEvents: this.filterHiddenEvents,
      };

      if (activeFilters.filterDate) queryParams.push(`calendar_date=${moment(activeFilters.filterDate).toISOString()}`);
      if (activeFilters.filterStudent) queryParams.push(`student=${activeFilters.filterStudent}`);
      if (activeFilters.filterLessonType) queryParams.push(`lessonType=${activeFilters.filterLessonType}`);
      if (activeFilters.filterInstructorCategory && activeFilters.filterInstructorCategory.length > 0) {
        queryParams.push(`instructor_category=${activeFilters.filterInstructorCategory.join(',')}`);
      }
      if (activeFilters.filterGroupLesson) queryParams.push(`group_lesson=${activeFilters.filterGroupLesson}`);
      if (activeFilters.filterLesson) queryParams.push(`lesson=${activeFilters.filterLesson}`);
      if (activeFilters.filterServices) queryParams.push(`services=${activeFilters.filterServices}`);
      if (activeFilters.filterHiddenEvents) queryParams.push(`hidden_events=${activeFilters.filterHiddenEvents}`);

      endpoint += queryParams.join('&');

      // Update component's filterDate to reflect current view range (for UI display)
      Promise.resolve().then(() => { this.filterDate = moment(this.newDateStart).toISOString(); });

      this._drupalRESTService.httpGET(endpoint).subscribe({
        next: (data: any) => {
          const events = Array.isArray(data) ? data : [];
          this.Events = this.fixEventColors(events);
          successCallback(this.Events);
        },
        error: (error) => {
          LoggerService.error('Error fetching calendar events:', error);
          this.handleError(error);
          failureCallback(error); // Notify FullCalendar of failure
        }
      });
    };
  }

  // Allow child classes to specify their events endpoint
  protected getEventsEndpoint(): string {
    return "/api/dayview/calendar/events?"; // Default for DayView
  }

  protected fixEventColors(events: any[]): any[] {
    if (!Array.isArray(events)) return [];
    return events.map(event => {
      const newEvent = { ...event }; // Create a shallow copy to avoid mutating original
      // Fix for events crossing day boundary
      if (moment(newEvent.end).isBefore(moment(newEvent.start))) {
        newEvent.end = moment(newEvent.end).add(1, 'days').format();
      }
      // Past event coloring (logic from DayViewComponent)
      // This logic was largely commented out or specific, adapt as needed.
      // if (moment(newEvent.end) < moment()) {
      //   if (newEvent?.appointmentType == 'lesson' && !['Showed', 'Cancelled', 'Rescheduled', 'No Showed Not Charged'].includes(newEvent?.status)) {
      //     newEvent.color = "#FF4136"; // Example: Overdue lessons
      //   }
      // }
      if (newEvent?.status === 'No Showed, Charged') newEvent.color = "#626267";
      if (newEvent?.status === 'Canceled Too Late') newEvent.color = "#626267";
      // if (newEvent?.status === 'Pending Status') newEvent.color = "#F2473F"; // Example: Pending events

      // Client-derived color wins over the server-supplied event.color.
      // Remove this line to fall back to the server-computed color.
      newEvent.color = this._eventColorService.getEventColor(newEvent);
      return newEvent;
    });
  }

  public getCalendarResources(filterParamsOverride: any = null) {
    return (fetchInfo: any, successCallback: (resources: any[]) => void, failureCallback: (error: any) => void) => {
      // Update slotMinTime/slotMaxTime based on fetched day's office hours
      const currentDayFormatted = moment(fetchInfo.startStr).format('dddd');
      const officeHoursForDay = this.AMTCalendarConfiguration?.['office_hours']?.[currentDayFormatted];
      if (officeHoursForDay?.start && this.calendarComponent?.getApi()) {
        this.calendarComponent.getApi().setOption('slotMinTime', officeHoursForDay.start);
        this.calendarComponent.getApi().setOption('slotMaxTime', officeHoursForDay.end);
      }

      let endpoint = this.getResourcesEndpoint();

      // Extract date-only and interpret in studio timezone for consistent week calculation
      const dateOnly = fetchInfo.startStr.split('T')[0];
      // Create a date string at noon in studio timezone to avoid any day boundary issues
      const dateForWeekCalc = moment.tz(dateOnly + ' 12:00', (this as any).studioTimezone).toISOString();

      const queryParams = [
        `start=${fetchInfo.startStr}`,
        `end=${fetchInfo.endStr}`,
        // Using custom week calculation to handle Week 53 logic correctly
        `week=${this.weekCalculationService.getWeekNumber(dateForWeekCalc)}`,
        `year=${this.weekCalculationService.getCorrectYearForWeek(dateForWeekCalc).toString()}`,
      ];

      const activeFilters = filterParamsOverride || {
        filterInstructorCategory: this.filterInstructorCategory,
      };

      if (activeFilters.filterInstructorCategory && activeFilters.filterInstructorCategory.length > 0) {
        queryParams.push(`instructor_category=${activeFilters.filterInstructorCategory.join(',')}`);
      }

      endpoint += queryParams.join('&');

      this._drupalRESTService.httpGET(endpoint).subscribe({
        next: (data: any) => {
          this.Resources = Array.isArray(data) ? data : [];
          this.calcSummary(this.Resources);
          successCallback(this.Resources);

          // Update tippy instances for resources (if info changed)
          this.Resources.forEach(resourceData => {
            const tippyInstance = this.tippyInstructorHoverInstances.get(resourceData.id);
            if (tippyInstance && resourceData.info) {
              tippyInstance.setContent(resourceData.info);
            }
          });
        },
        error: (error) => {
          this.handleError(error);
          failureCallback(error);
        }
      });
    };
  }

  // Allow child classes to specify their resources endpoint
  protected getResourcesEndpoint(): string {
    return "/api/dayview/calendar/resources?"; // Default for DayView
  }

  protected calcSummary(resourcesData: any[]): void {
    let alreadyCountedInstructorIds: string[] = []; // Use string for IDs
    this.summaryCount = { privateLessonDaily: 0, privateLessonWeekly: 0, privateTakenLessonDaily: 0, privateTakenLessonWeekly: 0 };

    // Aggregate the per-category breakdown across all instructors, preserving
    // the backend's category order. Keyed by category key while summing.
    const categoryOrder: string[] = [];
    const categoryMap: { [key: string]: any } = {};

    if (Array.isArray(resourcesData)) {
      resourcesData.forEach((element: any) => { // Assuming element structure from DayView
        if (element.id && !alreadyCountedInstructorIds.includes(element.id.toString())) {
          const booked = Array.isArray(element.privateLesson) && element.privateLesson.length >= 2 ? element.privateLesson : [0, 0];
          const taken = Array.isArray(element.privatePostedLesson) && element.privatePostedLesson.length >= 2 ? element.privatePostedLesson : [0, 0];

          this.summaryCount.privateLessonDaily += (booked[0] || 0);
          this.summaryCount.privateLessonWeekly += (booked[1] || 0);
          this.summaryCount.privateTakenLessonDaily += (taken[0] || 0);
          this.summaryCount.privateTakenLessonWeekly += (taken[1] || 0);

          (element.categoryBreakdown || []).forEach((row: any) => {
            if (!categoryMap[row.key]) {
              categoryMap[row.key] = {
                key: row.key,
                label: row.label,
                bookedDaily: 0, takenDaily: 0, bookedWeekly: 0, takenWeekly: 0,
              };
              categoryOrder.push(row.key);
            }
            categoryMap[row.key].bookedDaily += row.bookedDaily || 0;
            categoryMap[row.key].takenDaily += row.takenDaily || 0;
            categoryMap[row.key].bookedWeekly += row.bookedWeekly || 0;
            categoryMap[row.key].takenWeekly += row.takenWeekly || 0;
          });

          alreadyCountedInstructorIds.push(element.id.toString());
        }
      });
    }

    this.summaryBreakdown = categoryOrder.map(key => categoryMap[key]);
  }
  // --- END: Calendar Data Fetching and Processing ---


  // --- START: Configuration Fetching (Copied from DayViewComponent) ---
  protected getAMTSessionTime(): void {
    if (this._drupalRESTService) { // Ensure service is available
      this._drupalRESTService.httpGET("/api/dayview/calendar/configurations-session").subscribe(data => {
        this.AMTSessionTime = data;
        this.processAMTSessionTime();
      });
    }
  }

  protected processAMTSessionTime(): void {
    // This method uses jQuery to style table cells based on session times.
    // It assumes a certain DOM structure which might not be in BaseCalendar's template.
    // This is highly dependent on the view's template.
    if (!this.newDateStart || !this.AMTSessionTime || typeof $ === 'undefined') return;

    try {
      const currentDayDate = new Date(this.newDateStart);
      const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
      const dayName = daysOfWeek[currentDayDate.getDay()];
      const dataObject = this.AMTSessionTime;

      $('td.fc-timegrid-slot').css("background", ""); // Reset all slot backgrounds
      if (dataObject && dataObject[dayName] && Array.isArray(dataObject[dayName])) {
        dataObject[dayName].forEach((timeSlotStr: string) => {
          // FullCalendar data-time attributes are in 'HH:mm:ss' format
          // This jQuery selector might need adjustment based on FullCalendar's rendered HTML
          $(`td.fc-timegrid-slot[data-time="${timeSlotStr}"]`).css("background", "#ccc");
        });
      }
    } catch (e) {
      LoggerService.warn("Error processing AMTSessionTime (jQuery/DOM manipulation):", e);
    }
  }

  protected getAMTCalendarConfiguration(): void {
    if (this._drupalRESTService) {
      this._drupalRESTService.httpGET("/api/dayview/calendar/settings").subscribe({
        next: (data: any) => {
          this.AMTCalendarConfiguration = data;
          const currentDay = moment().format('dddd'); // Use current real day for initial settings
          const daySpecificHours = this.AMTCalendarConfiguration?.['office_hours']?.[currentDay];
          const minTime = daySpecificHours?.start || this.AMTCalendarConfiguration?.['office_hours']?.['minTime'] || "00:00:00";
          const maxTime = daySpecificHours?.end || this.AMTCalendarConfiguration?.['office_hours']?.['maxTime'] || "24:00:00";

          // Apply the studio's 12/24-hour preference to axis labels and event times.
          const timeFmt = getCalendarTimeFormat(data['time_format']);

          if (this.calendarComponent?.getApi()) { // If calendar is already initialized
            const api = this.calendarComponent.getApi();
            api.setOption('slotDuration', data['duration']);
            api.setOption('slotLabelInterval', data['slot_interval']);
            api.setOption('displayEventTime', data['event_time']);
            api.setOption('resourceOrder', data['resourceOrder'] || 'order_id');
            api.setOption('slotLabelFormat', timeFmt.slotLabelFormat);
            api.setOption('eventTimeFormat', timeFmt.eventTimeFormat);
            api.setOption('slotMinTime', minTime);
            api.setOption('slotMaxTime', maxTime);
          } else if (this.calendarOptions) { // If options object exists but calendar not yet rendered
             this.calendarOptions.slotDuration = data['duration'];
             this.calendarOptions.slotLabelInterval = data['slot_interval'];
             this.calendarOptions.displayEventTime = data['event_time'];
             this.calendarOptions.resourceOrder = data['resourceOrder'] || 'order_id';
             this.calendarOptions.slotLabelFormat = timeFmt.slotLabelFormat;
             this.calendarOptions.eventTimeFormat = timeFmt.eventTimeFormat;
             this.calendarOptions.slotMinTime = minTime;
             this.calendarOptions.slotMaxTime = maxTime;
          }
          // If neither, these values are stored in this.AMTCalendarConfiguration and initializeCalendarOptions will use them.
        },
        error: (error) => { LoggerService.error('Error loading calendar configuration:', error); this.handleError(error); }
      });
    }
  }

  protected getAMTFilterConfiguration(): void {
    if (this._drupalRESTService) {
      this._drupalRESTService.httpGET("/api/dayview/calendar/filterInit").subscribe(data => {
        this.filterLessonType = data['lessonTypes'];
        this.filterInstructorCategory = data['teacherCategory'];
        // this.filterInstructor = data['teacherCategory']; // Default filter to all categories
      });
    }
  }

  public getInstructorList(): void { // Public if called from outside/template
    if (this._drupalRESTService)
      this._drupalRESTService.httpGET("/api_rest/v1/teacherList").subscribe(data => this.InstructorList = data);
  }
  public getAMTAutocomplete(): void { // Public if called from outside/template
    if (this._drupalRESTService)
      this._drupalRESTService.httpGET("/api_rest/v1/autocomplete?").subscribe(data => this.AMTConfiguration = data);
  }
  // --- END: Configuration Fetching ---


  // --- START: Utility and Action Methods (Copied from DayViewComponent) ---
  override handleError(error: any): void {
    // Call super.handleError if BaseComponent has a generic error handler
    // super.handleError(error);
    LoggerService.error("Calendar Error:", error); // Log the error

    if (error.status === 403 || error.status === 401) { // 401 for Unauthorized
      this._authService?.set_user_authenticated(false);
      this._router?.navigate(['/auth/login'], { queryParams: { logged_out_inactive: true, returnUrl: this._router.url } });
    } else if (error.status === 400) {
        // Specific bad request handling, maybe show a generic message
        this.showSnackbar(error.error?.message || 'Invalid request. Please check your input.');
    }
    // Add more specific error handling as needed
  }

  public calcDuration(dateStart: moment.MomentInput, dateEnd: moment.MomentInput): string {
    const startDate = moment(dateStart);
    const endDate = moment(dateEnd);
    const duration = moment.duration(endDate.diff(startDate));
    const h = Math.floor(duration.asHours());
    const m = duration.minutes();
    return `${h < 10 ? "0" : ""}${h}:${m < 10 ? "0" : ""}${m}`;
  }

  public toggleEventConfirmation(eventArg: any): void {
    const fcEvent = eventArg.event; // FullCalendar Event object
    const eventDetails = fcEvent._def.extendedProps?.['eventDetails'];
    if (!eventDetails?.data || fcEvent._def.extendedProps?.['appointmentType'] !== 'lesson') return;

    const isConfirmed = eventDetails.data.isConfirmed;
    const eventID = fcEvent._def.extendedProps?.['entityId'];

    // Optimistic UI update (already handled by handleEventContent's re-render on data change)
    // Forcing a direct update:
    const newConfirmationState = !isConfirmed;
    eventDetails.data.isConfirmed = newConfirmationState;

    // Force FullCalendar to re-render this specific event.
    // Getting the event again by ID and setting a prop can trigger re-render.
    const calendarApiEvent = this.calendarComponent?.getApi()?.getEventById(fcEvent.id);
    if (calendarApiEvent) {
        calendarApiEvent.setExtendedProp('eventDetails', {...eventDetails}); // This should trigger re-render
    } else {
        this.refreshCalendar(50); // Fallback to full refresh if specific event update fails
    }


    this._entityRESTService.patchEntity('events', 'lesson', eventID, { field_is_confirmed: newConfirmationState })
      .subscribe({
        next: () => this.showSnackbar(newConfirmationState ? 'Thank you for confirming this lesson.' : 'Lesson confirmation has been removed.'),
        error: (error) => {
          LoggerService.error('Error updating confirmation status:', error);
          eventDetails.data.isConfirmed = isConfirmed; // Revert optimistic update
          if (calendarApiEvent) calendarApiEvent.setExtendedProp('eventDetails', {...eventDetails});
          else this.refreshCalendar(50);
          this.showSnackbar('Failed to update confirmation status. Please try again.');
          this.handleError(error);
        }
      });
  }

  public isEventHidden(): boolean {
    return this.copyData?.['field_exclude_from_display'] == 1;
  }
  public hideClick(): void { this.toggleEventVisibility(true); }
  public unhideClick(): void { this.toggleEventVisibility(false); }

  protected toggleEventVisibility(hide: boolean): void {
    $("#custom-context-menu").hide();
    const bundle = this.copyData?.['bundle'];
    const eventId = this.copyData?.['id'];
    if (!bundle || !eventId) { LoggerService.error('No event selected or missing bundle/id for visibility toggle.'); return; }

    this._entityRESTService.patchEntity('events', bundle, eventId, { field_exclude_from_display: [{ value: hide }]})
      .subscribe({
        next: () => {
          this.showSnackbar(`Event ${hide ? 'hidden' : 'unhidden'} successfully.`);
          this.refreshCalendar();
        },
        error: (error) => {
          LoggerService.error(`Error ${hide ? 'hiding' : 'unhiding'} event`, error);
          this.showSnackbar(`Failed to ${hide ? 'hide' : 'unhide'} event. Please try again.`);
          this.handleError(error);
        }
      });
  }

  public copyClick(): void {
    $("#custom-context-menu").hide();
    const bundle = this.copyData?.['bundle'];
    const entityType = 'events'; // Assuming 'events' is the ECK type
    if (!bundle || !this.copyData?.['id']) {
      LoggerService.error('Cannot copy: Missing bundle or event ID from copyData.');
      return;
    }

    let componentType: ComponentType<unknown>;
    let baseFieldsData: any = {}; // Will be populated based on bundle

    this._entityRESTService.getEntity(entityType, bundle, this.copyData['id']).subscribe(originalEntityData => {
      const ensureArray = (value: any) => Array.isArray(value) ? value : (value ? [value] : []);

      switch (bundle) {
        case 'lesson':
          componentType = this.EventLessonEntityComponent;
          baseFieldsData = {
            'field_type': originalEntityData?.['field_type'],
            'field_instructor': originalEntityData?.['field_instructor']?.['id'],
            'field_duration': this.copyData?.['eventDuration'], // from original event render data
            'field_date_and_time': originalEntityData?.['field_date_and_time'], // This will be new time eventually
            'field_student': ensureArray(originalEntityData?.['field_student']).map(s => ({
              ...this.prepareStudentData(s), // Keep existing student data
              'field_status': '64', // Reset status to Pending for copy
            }))
          };
          break;
        case 'services':
          componentType = this.EventServicesEntityComponent;
          baseFieldsData = {
            'field_type': originalEntityData?.['field_type'],
            'field_executive': originalEntityData?.['field_executive']?.['id'],
            'field_duration': this.copyData?.['eventDuration'],
            'field_date_and_time': originalEntityData?.['field_date_and_time'],
            'field_notes': originalEntityData?.['field_notes'], // Copy notes
            'field_student': ensureArray(originalEntityData?.['field_student']).map(s => this.prepareStudentData(s))
          };
          break;
        case 'group_lesson':
          componentType = this.EventGroupLessonEntityComponent;
          baseFieldsData = {
            'field_type': originalEntityData?.['field_type'],
            'field_instructor': ensureArray(originalEntityData?.['field_instructor']).map(inst => inst?.['id']),
            'field_duration': this.copyData?.['eventDuration'],
            'field_date_and_time': originalEntityData?.['field_date_and_time'],
            'field_students': ensureArray(originalEntityData?.['field_students']).map(s => ({
                ...this.prepareStudentData(s),
                'field_status': '64', // Reset status to Pending
            }))
          };
          break;
        case 'schedules':
          componentType = this.EventSchedulesEntityComponent;
          baseFieldsData = {
            'field_type': originalEntityData?.['field_type'],
            'field_duration': this.copyData?.['eventDuration'],
            'field_date_and_time': originalEntityData?.['field_date_and_time'],
            'field_schedule_instructor': ensureArray(originalEntityData?.['field_schedule_instructor']).map(inst => inst?.['id']),
          };
          break;
        default:
          LoggerService.error('Unsupported bundle type for copy:', bundle);
          this.showSnackbar(`Copying for type "${bundle}" is not supported.`);
          return;
      }

      // Open dialog for creating a new entity with pre-filled data from copy
      // The user will typically select a new date/time in the dialog.
      // We pass currentSelectedStartTime and currentSelectedDuration if available from a slot selection for the *new* event.
      const newEventInitialFields = {
        ...baseFieldsData,
        // If a slot was selected for "paste", use its time/instructor, otherwise dialog will handle.
        ...(this.currentSelectedStartTime && { 'field_date_and_time': [{ 'value': this.currentSelectedStartTime }] }),
        ...(this.currentSelectedDuration && { 'field_duration': this.currentSelectedDuration }),
        // Instructor might also come from currentSelectedInstructorID if applicable
      };

      this.openEntityComponent(componentType, entityType, bundle, 'create', null, newEventInitialFields);
    });
  }

  private prepareStudentData(studentData: any): any {
    if (!studentData) return null;
    // This should transform the student data from the GET request into the format expected by the POST/PATCH for field_student or field_students
    return {
      'type': studentData.type || 'attendees', // Default if not present
      'bundle': studentData.bundle || 'attendance', // Default if not present
      'title': studentData?.['title'],
      'field_description': studentData?.['field_description'],
      'field_enrollment': studentData?.['field_enrollment'], // This is likely an entity reference
      'field_status': studentData?.['field_status'], // Keep original status unless explicitly reset for copy
      'field_students': studentData?.['field_students'], // This is likely an entity reference
      'field_student_account': studentData?.['field_student_account'] // This is likely an entity reference or autocomplete string
        ? (typeof studentData.field_student_account === 'string' ? studentData.field_student_account : `${studentData.field_student_account.title} (${studentData.field_student_account.id || studentData.field_student_account.target_id})`)
        : undefined,
    };
  }

  public pasteClick(): void {
    // This was empty in DayViewComponent.
    // A full paste implementation would involve taking `this.copyData` (the source event's data),
    // then using `this.currentSelectedStartTime`, `this.currentSelectedDuration`, `this.currentSelectedInstructorID`
    // (which should be set by a `dateClick` or `select` on an empty slot where paste is intended)
    // to pre-fill a "create new event" dialog.
    // The `copyClick` method already fetches full entity data. This could be stored for paste.
    LoggerService.log('Paste clicked. Selected time slot data:', {
        start: this.currentSelectedStartTime,
        duration: this.currentSelectedDuration,
        instructor: this.currentSelectedInstructorID
    });
    this.showSnackbar('Paste functionality is conceptual. Use "Copy" then "Add..." in a new slot.');
    $("#custom-context-menu").hide();
  }

  public closeContextMenu(): void { $("#custom-context-menu").hide(); }

  public hideCustomPopover(): void {
    if (this.customPopover?.nativeElement) {
      this.customPopover.nativeElement.style.display = 'none';
    } else {
      $("#custom-popover").hide(); // Fallback
    }
  }

  // "Coaching" booking options (slot popover + New Event menu): one entry per
  // studio Coaching package. Same as the day view.
  public coachingPackages: { id: string, name: string }[] = [];
  public coachingPackagesLoading = false;
  public bookingMenuOpenKey = 0;

  /** Booking menu option picked for the clicked slot. */
  public onBookingMenuChoice(choice: BookingMenuChoice): void {
    const slot = {
      'field_duration': this.currentSelectedDuration,
      'field_date_and_time': this.currentSelectedStartTime,
    };
    switch (choice) {
      case 'lesson':
        this.openEntityComponent(this.EventLessonEntityComponent, 'events', 'lessons', 'create', '', { 'field_instructor': this.currentSelectedInstructorID, ...slot });
        break;
      case 'service':
        this.openEntityComponent(this.EventServicesEntityComponent, 'events', 'services', 'create', '', { 'field_executive': this.currentSelectedInstructorID, ...slot });
        break;
      case 'schedule':
        this.openEntityComponent(this.EventSchedulesEntityComponent, 'events', 'schedules', 'create', '', { 'field_schedule_instructor': [this.currentSelectedInstructorID], ...slot });
        break;
      case 'group_lesson':
        this.openEntityComponent(this.EventGroupLessonEntityComponent, 'events', 'group_lesson', 'create', '', { 'field_instructor': [this.currentSelectedInstructorID], ...slot });
        break;
      case 'inquiry':
        this.openEntityComponent(this.StudentInquiryEntityComponent, 'student_accounts', 'student_account', 'create', '', {
          'dayview_field_date_and_time': this.currentSelectedStartTime || this.calendarDateInquiry,
          'field_teacher': this.currentSelectedInstructorID,
          'inquiry': true
        });
        break;
    }
    this.hideCustomPopover();
  }

  public loadCoachingPackages(): void {
    this.coachingPackagesLoading = this.coachingPackages.length === 0;
    this._packagesService.getCoachingPackages().subscribe(packages => {
      this.coachingPackages = packages;
      this.coachingPackagesLoading = false;
    });
  }

  public openCoachingLesson(coachingPackage: { id: string, name: string }, fromSlot: boolean): void {
    const fieldsData: any = {
      'field_type': '1411',
      '__coaching_package': coachingPackage,
    };
    if (fromSlot) {
      fieldsData['field_instructor'] = this.currentSelectedInstructorID;
      fieldsData['field_duration'] = this.currentSelectedDuration;
      fieldsData['field_date_and_time'] = this.currentSelectedStartTime;
    }
    this.openEntityComponent(this.EventLessonEntityComponent, 'events', 'lessons', 'create', '', fieldsData);
  }

  /**
   * Determines the correct year to use for week-based calculations, especially at year boundaries.
   * Uses WeekCalculationService for correct Week 53 handling.
   */
  protected getCorrectYearForWeek(dateStr: string): number {
    return this.weekCalculationService.getCorrectYearForWeek(dateStr);
  }

  override refreshCalendar(delay: number = 0): void {
    if (this.isDragging) return;

    this.nextEventsCache.clear(); // Clear cache on full refresh
    // Consider clearing pendingRequests as well, or implementing cancellation

    setTimeout(() => {
      if (this.calendarComponent && this.calendarComponent.getApi()) {
        this.calendarComponent.getApi().refetchEvents();
        this.calendarComponent.getApi().refetchResources();
        this.processAMTSessionTime(); // Re-apply session time styling
      }
    }, delay);
  }
  // --- END: Utility and Action Methods ---


  // --- START: Next Events Logic (Copied from DayViewComponent) ---
  protected formatNextEventsHtml(nextEvents: any): string {
    if (!nextEvents) return '<div class="next-events-container"><p>No upcoming appointments data.</p></div>';

    const hasNoUpcomingEvents =
      (!nextEvents.upcomingEventList || nextEvents.upcomingEventList.length === 0) &&
      (!nextEvents.upcomingEvent || ['<p>No Appointments Available</p>', '<p>Click for upcoming appointments</p>'].includes(nextEvents.upcomingEvent)) &&
      (!nextEvents.nextdate || ['NFA', ' NFA'].includes(nextEvents.nextdate));

    if (hasNoUpcomingEvents) return '<div class="next-events-container"><p>No upcoming appointments found.</p></div>';

    let html = '<div class="next-events-container"><h4>Upcoming Appointments</h4>';
    if (nextEvents.upcomingEventList && nextEvents.upcomingEventList.length > 0) {
      html += '<ul class="next-events-list">';
      nextEvents.upcomingEventList.forEach((event: any) => {
        let displayText = 'Event data missing';
        if (typeof event === 'string') { // Assuming it's a date string
          displayText = moment(event).format('ddd, MMM D, YYYY - h:mm A');
        } else if (typeof event === 'object' && (event.dateFormatted || event.date)) {
          displayText = event.title ? `${this.escapeHtml(event.title)} - ` : '';
          displayText += this.escapeHtml(event.dateFormatted || moment(event.date).format('ddd, MMM D, YYYY - h:mm A'));
        }
        html += `<li class="next-event-item"><i class="fa fa-calendar" aria-hidden="true"></i> ${displayText}</li>`;
      });
      html += '</ul>';
    } else if (nextEvents.upcomingEvent && !['<p>No Appointments Available</p>', '<p>Click for upcoming appointments</p>'].includes(nextEvents.upcomingEvent)) {
      // Attempt to use the HTML string from upcomingEvent
      html += nextEvents.upcomingEvent; // This might be pre-formatted HTML
    } else if (nextEvents.nextdate && !['NFA', ' NFA'].includes(nextEvents.nextdate)) {
      html += `<p><i class="fa fa-calendar" aria-hidden="true"></i> Next appointment: ${this.escapeHtml(nextEvents.nextdate)}</p>`;
    } else {
      html += '<p>No upcoming appointments.</p>'; // Fallback
    }
    html += '</div>';
    return html;
  }

  /** Escapes a value before it is interpolated into HTML assigned to innerHTML. */
  private escapeHtml(value: any): string {
    return String(value ?? '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  private createNextEventsCacheKey(eventId: string, dateStr: string): string {
    try {
      const normalizedDate = moment(dateStr).format('YYYY-MM-DD'); // Normalize to date part only
      return `next-events-${eventId}-${normalizedDate}`;
    } catch (error) {
      LoggerService.warn(`[API_CACHE_KEY] Error normalizing date for cache key: ${dateStr}`, error);
      return `next-events-${eventId}-${dateStr}`; // Fallback
    }
  }

  private loadNextEvents(eventId: string, date: string, studentId: string | null, onSuccess: (data: any) => void, onError: (error: any) => void): void {
    const normalizedDateForCache = moment(date).format('YYYY-MM-DD'); // Date only for cache key
    const cacheKey = this.createNextEventsCacheKey(eventId, normalizedDateForCache);

    if (this.nextEventsCache.has(cacheKey)) {
      onSuccess(this.nextEventsCache.get(cacheKey));
      return;
    }
    if (this.pendingRequests.has(cacheKey)) {
      this.pendingRequests.get(cacheKey)!
        .then(data => onSuccess(data))
        .catch(error => onError(error));
      return;
    }

    const apiDateStr = moment(date).format('YYYY-MM-DDTHH:mm:ss'); // Full timestamp for API
    const requestPromise = this.fetchNextEvents(studentId, eventId, apiDateStr);
    this.pendingRequests.set(cacheKey, requestPromise);

    requestPromise
      .then(data => { this.nextEventsCache.set(cacheKey, data); onSuccess(data); })
      .catch(error => { onError(error); })
      .finally(() => { this.pendingRequests.delete(cacheKey); });
  }

  private fetchNextEvents(studentAccountId: string | null, currentEventId: string, date: string): Promise<any> {
    if (!currentEventId || !date) return Promise.reject('Missing required parameters for fetchNextEvents');
    let endpoint = `/api/dayview/calendar/next_events?current_event_id=${currentEventId}&date=${date}`;
    if (studentAccountId) endpoint += `&student_account_id=${studentAccountId}`;

    return new Promise<any>((resolve, reject) => {
      this._drupalRESTService.httpGET(endpoint).subscribe({
        next: (data) => resolve(data || { upcomingEventList: [] }), // Ensure data is at least an empty structure
        error: (error) => { LoggerService.error(`[API] Error fetching next events for event ${currentEventId}:`, error); reject(error); }
      });
    });
  }

  // onShowTooltip was part of DayViewComponent but seems to duplicate logic in handleEventDidMount's tippy onShow.
  // If it's a separate public method called from a template, it can be kept.
  // For now, assuming handleEventDidMount covers tooltip logic.
  // --- END: Next Events Logic ---
}
